import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import api from './api/api'
import './plugins/element.js'
import '../theme/index.css'
import './assets/iconfont/iconfont.css'
import './assets/lh.less'
import ElementUi from 'element-ui'
import moment from 'moment'
import 'videojs-contrib-hls'
import uploader from 'vue-simple-uploader'

Vue.config.productionTip = false
Vue.prototype.$api = api
Vue.prototype.$moment = moment
Vue.use(router)
Vue.use(ElementUi)
Vue.use(VueAxios, axios);
Vue.use(uploader)
new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
if (localStorage.getItem('user') && router.history._startLocation != '/sxt') {
  // if (router.history.current.name == 'admin') {
  //   router.push({ path: '/admin' })
  // } else {
  //   router.push({ path: '/login' })
  // }

} else {
  if (router.history._startLocation == '/sxt') {
    router.push({ path: '/sxt' })
  } else if (router.history._startLocation == '/lookTbwj') { 
    router.push({ path: '/lookTbwj' })
  } else {
    if (!router.history.current.name) {
      if (localStorage.getItem('role') == 'M') {
        router.push({ path: '/zygl' })
      } else {
        router.push({ path: '/kbxmList' })
      }
    }
  }
}

// 白名单直接访问
const whiteList = ['login', 'bj', 'logout', 'ssoLogin', 'test', 'lookTbwj']

router.beforeEach((to, from, next) => {
  //根据字段判断是否路由过滤
  console.log('to', to)
  if (to.matched.some(m => m.meta.auth)) {
    if (localStorage.getItem('user') !== null) {
      next()
    } else {
      //防止无限循环
      if (whiteList.includes(to.name)) {
        next();
        return
      }
      next({
        path: '/login',
      });
    }
  } else {
    next()//若点击的是不需要验证的页面,则进行正常的路由跳转
  }
});